import axios, { AxiosResponse } from 'axios';

export interface IBankID {
    typ: string;
    idzadosti?: string;
}

export interface IBankIDData {
    urlbankid: string;
    code?: number;
    message?: string;
}

const nuBankidApi = (idzadosti?: string) => {
    return axios({
        method: 'POST',
        url: '/EU/bankid',
        data: {
            idzadosti
        }
    }).then((resp: AxiosResponse<IBankIDData>) => resp.data);
};

export interface IZadost {
    token: string;
}

export interface IZadostDataNU {
    idzadosti?: string;
    jmeno?: string;
    prijmeni?: string;
    email?: string;
    rodnecislo?: string;
    cjdedictvi?: string;
    telefon?: string;
    datum?: string;
    stav?: ['IDEN', 'ZAPLA', 'CEKA', 'ZPRAC', 'VYPR'];
    ulice?: string;
    mesto?: string;
    psc?: string;
}

export const nuZadostApi = (token: string) => {
    return axios({
        method: 'GET',
        url: '/EU/zadost',
        headers: {
            Authorization: `Bearer ${token}`
        }
    }).then((resp: AxiosResponse<IZadostDataNU>) => resp.data);
};

export interface IPlatba {
    token: string;
    idzadosti: string;
}

export interface IPlatbaData {
    urlbankid: string;
    code?: number;
    message?: string;
}

export const nuPlatbaApi = (token: string, idzadosti: string) => {
    return axios({
        method: 'POST',
        url: '/EU/platba',
        headers: {
            Authorization: `Bearer ${token}`
        },
        data: {
            idzadosti
        }
    }).then((resp: AxiosResponse<IPlatbaData>) => resp.data);
};

export interface IObjenat {
    idzadosti: string;
    email: string;
    telefon: string;
    rodnecislo: string;
    cjdedictvi: string;
    ulice: string;
    mesto: string;
    psc: string;
}

export interface IObjenatData {
    code?: number;
    message?: string;
}

export const nuObjednatApi = (token: string, data: IObjenat) => {
    return axios({
        method: 'POST',
        url: '/EU/objednat',
        headers: {
            Authorization: `Bearer ${token}`
        },
        data: data
    }).then((resp: AxiosResponse<IObjenatData>) => resp);
};

export const nufileDownload = (
    fileType: 'pdf' | 'xml' | 'zip' | 'html',
    token: String,
    typ: 'vypis' | 'faktura'
    // fileName?: string
) => {
    return axios({
        method: 'GET',
        url: `/EU/zadost/DownloadPDF?typ=${typ}`,
        headers: {
            Authorization: `Bearer ${token}`
        },
        responseType: 'blob' // important
    }).then(resp => {
        if (resp.status === 200) {
            let fileName = '';

            if (typ === 'vypis') {
                fileName = 'Zjištění majetkového účtu';
            } else if (typ === 'faktura') {
                fileName = 'Faktura';
            } // TODO: Predelat na nejakej lepsi zpusob... rn nevim jak to s tim typem bude :D

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // IE
                window.navigator.msSaveOrOpenBlob(resp.data, fileName);
            } else {
                const odp = resp.data;
                const uriContent = URL.createObjectURL(
                    new Blob([odp], {
                        type: `application/${fileType}`
                    })
                );
                const link = document.createElement('a');
                link.style.display = 'none';
                // link.download = fileName || 'Výpis z nezařazeného účtu';
                link.download = fileName || 'pdf';
                link.href = uriContent;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    });
};

export default nuBankidApi;
